module.exports = __webpack_public_path__ + "static/estacion-belen-f0fa2cf3541f79cebfe841f77e77b3c6.jpg";